import { createSelector } from 'reselect';
import { PhoneNumber, PricingItem } from './pricing-numbers';
import {
  CLEAR_NUMBERS_LOADED_STATE,
  GET_NUMBERS_SUCCESS,
  GET_PRICING_NUMBERS_SUCCESS, ORDER_INITIAL_NUMBER, ORDER_INITIAL_NUMBER_FAILURE, ORDER_INITIAL_NUMBER_SUCCESS,
  PricingNumbersAction,
  SET_AVAILABLE_NUMBER_TYPES
} from './pricing-numbers.action';

export interface PricingNumbersState {
  documents: object;
  pricing: PricingItem[];
  numbers: PhoneNumber[];
  areNumbersLoaded: boolean;
  availableTypes: string[];
  orderingInitialNumber: boolean;
}

export const initialState: PricingNumbersState = {
  documents: null,
  pricing: [],
  numbers: [],
  areNumbersLoaded: false,
  availableTypes: [],
  orderingInitialNumber: false,
};

export function pricingNumbersReducer(
  state: PricingNumbersState = initialState,
  action: PricingNumbersAction
): PricingNumbersState {
  switch (action.type) {
    case GET_PRICING_NUMBERS_SUCCESS:
      const payload = action.payload;
      return {
        ...state,
        documents: payload.documents,
        pricing: payload.pricing,
        numbers: [],
        areNumbersLoaded: false
      };
    case CLEAR_NUMBERS_LOADED_STATE:
      return {
        ...state,
        areNumbersLoaded: false
      };
    case GET_NUMBERS_SUCCESS:
      return {
        ...state,
        numbers: action.payload,
        areNumbersLoaded: true
      };
    case SET_AVAILABLE_NUMBER_TYPES:
      return {
        ...state,
        availableTypes: action.payload
      };
    case ORDER_INITIAL_NUMBER:
      return {
        ...state,
        orderingInitialNumber: true,
      }
    case ORDER_INITIAL_NUMBER_SUCCESS:
    case ORDER_INITIAL_NUMBER_FAILURE:
      return {
        ...state,
        orderingInitialNumber: false,
      }

    default: {
      return state;
    }
  }
}

export const getPricing = (state: PricingNumbersState) => state.pricing;
export const getNumbers = (state: PricingNumbersState) => state.numbers;
export const getAreNumbersLoaded = (state: PricingNumbersState) => state.areNumbersLoaded;
export const getAvailableTypes = (state: PricingNumbersState): string[] => state.availableTypes;
export const getDocuments = (state: PricingNumbersState): object => state.documents;
export const getOrderingInitialNumber = (state: PricingNumbersState): boolean => state.orderingInitialNumber;

export const getMainPricingNumberSelector = (state): PricingNumbersState => state.pricingNumbers;
export const getPricingSelector = createSelector(getMainPricingNumberSelector, getPricing);
export const getNumbersSelector = createSelector(getMainPricingNumberSelector, getNumbers);
export const getAreNumbersLoadedSelector = createSelector(getMainPricingNumberSelector, getAreNumbersLoaded);
export const getAvailableTypesSelector = createSelector(getMainPricingNumberSelector, getAvailableTypes);
export const getDocumentsSelector = createSelector(getMainPricingNumberSelector, getDocuments);
export const getOrderingInitialNumberSelector = createSelector(getMainPricingNumberSelector, getOrderingInitialNumber);
